import React from "react";
import numeral from "numeral";
import lodash from "lodash";
import moment from "moment";
import { useNavigate } from "react-router-dom";
//outsource
import { Row, Col, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../../../store/var/var.action";
import { setDateLabel } from "../../../store/var/var.action";
import { getHeaderRows, getDataRows } from "../../../utils/refine.cashupreport";

const CashupReportTable = (props) => {
  // -------------------------- VAR --------------------------
  const { data } = props;
  const navigate = useNavigate();
  const totalIncome = lodash.sumBy(data, (item) => item.totalIncome);
  const totalReceivable = lodash.sumBy(data, (item) => item.totalReceivable);

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const sortData = (data) => {
    return data.slice().sort((a, b) => b.date - a.date);
  };

  const handleDate = (date) => {
    dispatch(setDate({ data: date }));
  };

  const handleDateLabel = (label) => {
    dispatch(setDateLabel({ data: label }));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const dataRange = getDataRows(sortData(data));
  const columns = getHeaderRows();

  const finalIncome = numeral(totalIncome).format("0,0.00");
  const finalReceivable = numeral(totalReceivable).format("0,0.00");
  const total = dataRange.length;

  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col style={{ marginTop: 5 }} align="right" span={24}>
        Total:{" "}
        <span style={{ color: "green", fontWeight: "bold" }}>
          ${finalIncome}
        </span>{" "}
        |{" "}
        <span style={{ fontWeight: "bold", color: "red" }}>
          ${finalReceivable}
        </span>
      </Col>
      <Col span={24}>
        <Table
          bordered
          columns={columns}
          dataSource={dataRange || []}
          pagination={{
            position: ["bottomRight"],
            pageSize: 50,
            defaultCurrentPage: 1,
            total: { total },
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                let date = record?.date;
                date = date && moment(date?.toDate());
                const dateLabel = date?.format("DD/MM/YYYY");
                handleDateLabel(dateLabel);
                handleDate(date);
                navigate(`/report/cashup/${record?.shopId}/detail`);
              },
            };
          }}
        />
      </Col>
    </Row>
  );
};

export default CashupReportTable;
